import { Button, Container, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { appUpdateVersion } from '../../utils/config';

export default function Onboarder({ title, desc, desc2, img, final }) {
    const navigate = useNavigate();

    return (
        <Container
            maxWidth="sm"
            style={{
                paddingTop: 52,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
            }}
        >
            <div
                style={{
                    width: window.innerWidth * 0.4,
                    height: window.innerWidth * 0.4,
                    display: 'flex',
                    justifyContent: 'flex-end',
                }}
            >
                <img
                    style={{
                        width: '100%',
                        marginTop: 'auto',
                    }}
                    src={img}
                    alt={title}
                />
            </div>
            <Typography
                style={{ marginBottom: 10, marginTop: 20 }}
                variant="h4"
            >
                {title}
            </Typography>
            <Typography color="text.secondary">{desc}</Typography>
            <Typography color="text.secondary">{desc2}</Typography>
            {final && (
                <Button
                    variant="outlined"
                    style={{ marginTop: 30 }}
                    onClick={() => {
                        localStorage.setItem(appUpdateVersion, true);
                        navigate('/');
                    }}
                >
                    Get Started
                </Button>
            )}
        </Container>
    );
}
